import React, { useState, useEffect } from 'react';
import { Car, Clock, MapPin, CheckCircle, ArrowRight } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PrivateTours = () => {
  const [privateTourSamples, setPrivateTourSamples] = useState([]);
  const [loading, setLoading] = useState(true);

  const whatsappNumber = '917827327243';
  const whatsappMessage = 'Hi! I want to enquire about a private full-day Delhi tour.';

  useEffect(() => {
    const fetchPrivateTours = async () => {
      try {
        const response = await axios.get(`${API}/private-tours`);
        setPrivateTourSamples(response.data);
      } catch (error) {
        console.error('Error fetching private tours:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPrivateTours();
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section
        style={{
          background: `linear-gradient(rgba(255, 254, 242, 0.85), rgba(255, 254, 242, 0.85)), url('https://images.unsplash.com/photo-1688781298681-ae1f2d470b31')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '100px 0',
          textAlign: 'center'
        }}
      >
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>Private Full-Day Delhi Tours</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto 32px' }}>
            Customizable private tours with expert guide and comfortable vehicle. Perfect for families, VIP guests, and those seeking a personalized experience.
          </p>
          <a
            href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Quick WhatsApp Enquiry
            <ArrowRight size={18} />
          </a>
        </div>
      </section>

      {/* What's Included */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '60px' }}>What's Included</h2>
          <div className="grid-three-column">
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: '60px', height: '60px', border: '1px solid var(--border-medium)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                <Car size={28} color="var(--text-primary)" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>Private Vehicle</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Air-conditioned car with professional driver for the entire day
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: '60px', height: '60px', border: '1px solid var(--border-medium)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                <MapPin size={28} color="var(--text-primary)" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>Expert Guide</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Dedicated historian guide with deep local knowledge
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: '60px', height: '60px', border: '1px solid var(--border-medium)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                <Clock size={28} color="var(--text-primary)" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>Flexible Pacing</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Customize your itinerary and spend time as you wish
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sample Itineraries */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{ marginBottom: '48px', textAlign: 'center' }}>
            <h2 className="heading-1" style={{ marginBottom: '16px' }}>Sample Itineraries</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              Choose from our curated itineraries or create your own
            </p>
          </div>
          <div className="grid-three-column">
            {privateTourSamples.map((sample) => (
              <div
                key={sample.sample_id}
                style={{
                  background: 'var(--bg-primary)',
                  border: '1px solid var(--border-light)',
                  padding: '32px'
                }}
              >
                <h3 className="heading-3" style={{ marginBottom: '12px' }}>{sample.title}</h3>
                <p className="body-small" style={{ color: 'var(--text-light)', marginBottom: '24px' }}>
                  {sample.duration}
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {sample.highlights.map((highlight, idx) => (
                    <li key={idx} style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                      <CheckCircle size={18} color="var(--text-primary)" style={{ flexShrink: 0, marginTop: '2px' }} />
                      <span className="body-regular">{highlight}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Removed Enquiry Form - WhatsApp is primary contact method */}
    </div>
  );
};

export default PrivateTours;